module.exports = __webpack_public_path__ + "img/page1-bg.c1fd8462.png";